/**
 * A new version of the app: a service worker waiting, or the server delivering another build. Applied
 * only when the person taps "Neu laden" (main.tsx); `server` hears the version on every API answer.
 */
export const update = {
  ready: false,
  /** True once the page is on its way to the new version; false when it could not (no connection). */
  apply: async (): Promise<boolean> => false,
  server: (_version: string) => {},
};
